import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button',
  standalone: false,
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() text?: string;
  @Input() color?: string;
  @Input() size?: string;
  @Input() icon?: string;
  @Input() disabled?: string;

  class: string = '';

  // Funzione per generare l'oggetto di classi
  getClassObject() {
    const classObj: any = {
      button: true, // La classe 'button' è sempre applicata
      'material-icons': !!this.icon, // La classe 'material-icons' è applicata se 'icon' è definita
    };

    // Aggiungi condizionalmente le classi 'color' e 'size' se sono definite
    if (this.color) {
      classObj[this.color] = true;
    }
    if (this.size) {
      classObj[this.size] = true;
    }
    if (this.disabled) {
      classObj[this.disabled] = true;
    }

    return classObj;
  }
}
